import React from 'react';

interface VideoViewerProps {
  url: string;
}

const VideoViewer: React.FC<VideoViewerProps> = ({ url }) => {
  return (
    <div style={{ 
      width: '100vw', 
      height: '100vh', 
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: '#000000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <video
        src={url}
        controls
        autoPlay
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
      >
        브라우저가 비디오를 지원하지 않습니다.
      </video>
    </div>
  );
};

export default VideoViewer;
